import { LuArrowDown, LuArrowUp } from "react-icons/lu";

import { MIN_DESO_TOKEN_PCT_CHANGE_TO_HIGHLIGHT_TRENDING } from "@/utils/constants";
import { abbreviateNumber } from "@/utils/helpers";
import { cn } from "@/utils/lib";

interface CoinPriceFormatterProps {
  price: number;
  className?: string;
  numberClassName?: string;
  highPriceThreshold?: number;
  maximumFractionDigits?: number;
  arrowSize?: number;
  showArrow?: boolean;
}

const CoinPriceChangePercentageFormatter = ({
  price,
  className = "",
  numberClassName = "",
  highPriceThreshold = 100,
  maximumFractionDigits = 0,
  showArrow = true,
  arrowSize = 16,
}: CoinPriceFormatterProps) => {
  const pricePct = Number(price);
  const isUptrend = pricePct >= MIN_DESO_TOKEN_PCT_CHANGE_TO_HIGHLIGHT_TRENDING;
  const isDowntrend = pricePct < 0;

  return (
    <div
      className={cn(
        "flex items-center gap-1 font-mono text-sm",
        `
          ${showArrow && isUptrend && "font-shadow-green text-emerald-400"}
        `,
        `
          ${showArrow && isDowntrend && "text-red-600"}
        `,
        `
          ${showArrow && !isUptrend && !isDowntrend && "text-muted"}
        `,
        className,
      )}
    >
      {showArrow && (
        <>
          {isUptrend && <LuArrowUp size={arrowSize} className="text-base" />}
          {isDowntrend && (
            <LuArrowDown size={arrowSize} className="text-base" />
          )}
        </>
      )}
      <div
        className={cn("inline-flex items-center font-mono", numberClassName)}
      >
        {abbreviateNumber(price, {
          maximumFractionDigits:
            price >= highPriceThreshold ? maximumFractionDigits : 2,
        })}
        %
      </div>
    </div>
  );
};

export default CoinPriceChangePercentageFormatter;
